import { Box, Stack, Typography } from "@mui/material";
import { LicenseOptionImage } from "Components/Licenses/LicenseOptionImage";
import { LICENSE_CODE_TO_DATA_MAP } from "Components/Licenses/licenseUtils";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";

type Props = {
  license: PartyLicenseDto;
  label: string;
};

// Non-interactive counterpart of the license Dropdown option: same field look
// (label, bordered box, artwork thumbnail, name), used when there is only one
// pending license and there is nothing to pick from.
export const PendingLicenseDisplay = ({ license, label }: Props) => {
  const name = `${LICENSE_CODE_TO_DATA_MAP[license.code].title} (${license.region})`;

  return (
    <Stack width="100%" textAlign="left" gap={1}>
      <Typography>{label}</Typography>
      <PrimaryPaper>
        <Box display="flex" alignItems="center" gap={3}>
          <LicenseOptionImage license={license} />
          <Typography fontSize={16} fontWeight={500}>
            {name}
          </Typography>
        </Box>
      </PrimaryPaper>
    </Stack>
  );
};
